export enum AdminTypes {
    login = '[auth] Login',
    logout= '[auth] Logout',
};